export const SELECT_SUB_CUENTA = [
    {
        value: 0,
        label: 'Principal',
    },
    {
        value: 1,
        label: 'SubUser',
    },
];